import type { ComputedRef, InjectionKey } from 'vue'
import type { WebsiteForm } from './types'

export interface FormsContext {
  forms: ComputedRef<Map<string, WebsiteForm>>
}

export const formsContextKey: InjectionKey<FormsContext> = Symbol('forms-context')
